module.exports = __webpack_public_path__ + "img/circle.660cdd74.png";